export default function TermsOfService() {
  return (
    <div className="flex flex-col items-center font-sans px-4">
      <h1 className="text-[#5C2D91] text-center font-bold max-w-[90%]">Termos de Serviço</h1>
      <p><strong>Última atualização:</strong> 14 de maio de 2025</p>

      <p>Bem-vindo ao site <a href="https://visageai.sofiq.com.br" target="_blank" rel="noopener noreferrer">visageai.sofiq.com.br</a>, operado por Sofiq.ai. Ao acessar ou utilizar nosso site, você concorda com os termos e condições descritos abaixo.</p>

      <h2>1. Uso do Site</h2>
      <p>Você concorda em usar o site de forma legal e ética. É proibido:</p>
      <ul>
        <li>Usar o site para fins ilícitos;</li>
        <li>Tentar acessar sistemas não autorizados;</li>
        <li>Prejudicar o desempenho ou segurança da plataforma.</li>
      </ul>

      <h2>2. Cadastro e Acesso</h2>
      <p>O uso de certas funcionalidades pode exigir cadastro. Você é responsável pelas suas credenciais e pelo uso feito da sua conta.</p>

      <h2>3. Propriedade Intelectual</h2>
      <p>Todo conteúdo do site é de propriedade da Sofiq.ai ou de terceiros licenciadores. É proibida a reprodução ou redistribuição sem autorização.</p>

      <h2>4. Privacidade</h2>
      <p>O uso de dados pessoais está detalhado em nossa <a href="/politica-de-privacidade">Política de Privacidade</a>. Ao usar o site, você aceita esses termos.</p>

      <h2>5. Limitação de Responsabilidade</h2>
      <p>A Sofiq.ai não se responsabiliza por danos decorrentes do uso ou da indisponibilidade do site.</p>

      <h2>6. Alterações nos Termos</h2>
      <p>Podemos atualizar estes termos a qualquer momento. As mudanças serão válidas a partir da data de publicação.</p>

      <h2>7. Contato</h2>
      <p>Para dúvidas, entre em contato:</p>
      <ul>
        <li><strong>E-mail:</strong> <a href="mailto:alessandro.silveira@sofiq.com.br">alessandro.silveira@sofiq.com.br</a></li>
        <li><strong>Site:</strong> <a href="https://visageai.sofiq.com.br" target="_blank" rel="noopener noreferrer">visageai.sofiq.com.br</a></li>
      </ul>
    </div>
  );
}
